import { MarketContent } from './component';


export default MarketContent;
